var _style, _path, _g, _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolicAcidDeficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFC05D;}\n\t.st1{fill:#284F23;}\n\t.st2{fill:none;stroke:#417E31;stroke-width:3.0101;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{opacity:0;clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.2,96.1c-0.6-2.5-2.7-4.6-5.2-4.9c-1.4-0.2-2.8,0.2-4.1,0.7s-2.6,1.2-3.8,2c-2,1.4-3.8,3.2-6.1,3.6 c-1.6,0.3-3.3-0.2-5-0.1c-1.7,0-3.5,0.8-4,2.4c0,0-4.6,1.3-3.3,3.7l-1.4,3.7c0,0,0,0.1,0,0.1c-0.1,0.2-0.2,0.4-0.4,0.5 c-0.7,0.8-1.6,1.4-2.6,1.6c-0.8,0.2-1.5,0.1-2.3,0.3c-2,0.6-3.1,2.9-3.2,5.1c-0.2,2.1,0.3,4.3-0.1,6.4c-0.4,1.8-1.4,3.5-2.8,4.6 c-0.6,0.5-1.3,0.9-1.7,1.6c-1.1,1.8,0.5,4.1-0.2,6.1c-0.3,1.1-1.2,1.8-1.6,2.8c-1,2.1-0.1,4.4,1.1,6.5c0.2,0.3,0.3,0.5,0.5,0.8 l0.4-0.4c2.6-4.6,5.7-8.9,9-13c0,0,0,0,0,0v0c0,0,0,0,0,0c3.2-3.9,6.7-7.5,10.5-10.8l0,0c5.6-4.9,11.8-9.1,18.4-12.5 c1.3-0.7,2.6-1.1,3.8-1.7c0.8-0.5,1.7-1,2.3-1.8C159,101.2,159.8,98.5,159.2,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,114.5c-0.5-1.7-2.2-3-2.4-4.8c-0.3-2,1.1-3.9,0.7-5.8c-0.2-1.1-1-2-1.4-3c-1.1-2.8,0.4-6.1-0.2-9 c-0.6-3.3-3.7-5.8-3.7-9.2c0-2.3,1.4-5-0.1-6.8c-1.3-1.7-4.1-1.3-5.6-2.7c-1.7-1.7-0.9-4.8-2.2-6.8c-0.9-1.2-2.4-1.7-3.9-1.9 c-1.5-0.2-3,0-4.5-0.2c-2.1-0.3-4-1.4-5.4-3c-0.8-1-2.1-2.2-3.1-1.4c-0.4,0.3-0.5,0.9-0.8,1.4c-1.4,3.3-6.7,3.7-7.4,7.1 c-0.3,1.3,0.3,2.7,0.1,4.1c-0.4,2.4-3.2,4.1-3.1,6.5c0,1.1,0.7,2.2,0.7,3.3c0.1,2.5-2.8,4.3-2.9,6.8c-0.1,2.8,3.3,4.8,3.2,7.5 c0,1.7-1.4,3.1-1.5,4.8c-0.3,3.6,4.5,5.6,5.5,9c0.5,1.7,0.2,3.7,1.1,5.2c1.8,3.1,7.5,2.3,8.8,5.6c0.4,1.1,0.2,2.4,0.6,3.4 c1.3,2.9,6.4,1.6,8.3,4.1c1.1,1.4,0.8,3.4,1.4,5.1c0.6,1.9,2.3,3.3,4.1,4.3c1.8,1,3.7,1.6,5.4,2.7c0.8,0.5,1.4,1.1,2,1.7 c1,1.1,1.7,2.3,2.6,3.6c0,0.1,0.1,0.2,0.2,0.2c1.3-1.6,1.2-6.4,1.7-8.6c0.7-2.9,1.4-5.8,1.5-8.8c0.1-2.8-0.5-5.6-0.1-8.3 C107.4,118.6,108.3,116.5,107.6,114.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.4,142.5c-1.4-2.2-2.8-4.9-1.7-7.3c0.5-1,1.3-1.8,1.6-2.8c0.6-2-0.9-4.3,0.2-6.1c0.4-0.7,1.1-1.1,1.7-1.6 c1.4-1.2,2.4-2.8,2.8-4.6c0.4-2.1,0-4.3,0.1-6.4s1.1-4.5,3.2-5.1c0.7-0.2,1.5-0.2,2.3-0.3c1-0.2,2-0.8,2.6-1.6 c0.6-0.7,1-1.7,1.6-2.4s1.7-1.3,2.5-0.9c0.6,0.3,0.9,0.8,1.4,1.2c0.7,0.5,1.7,0.5,2.6,0.1c0.8-0.3,1.6-0.9,2.3-1.4 c1.6-1.1,3.5-1.9,5.4-1.5c1.7,0.3,3.1,1.6,4.6,2.3c2.9,1.5,6.7,1.2,9.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.8,119c0.7,3.6,0.8,6.5,0,10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.4,109.7c0.2,2.9-0.2,5.9-1.2,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.4,78.2c14.2,23.9,21.2,51.4,27.4,78.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.8,79.5c-0.2,0.1-0.1-0.3,0.1-0.2c0.2,0.1,0.2,0.3,0.1,0.5c-1,5.7-1.1,13.1-0.4,18.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.1,102c-1.2,6.2-2.4,11.9-1.8,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,88.4c1.6,0.6,3.1,1.3,4.7,1.9c0.8,0.3,1.6,0.7,2.4,1c4.1,1.8,7.8,4.4,11.3,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.7,108.5c1.1,0.3,2.1,0.7,3.1,1.2c5.7,2.7,11,6.2,15.6,10.5"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolicAcidDeficiency);
export default __webpack_public_path__ + "static/media/Folic_Acid_Deficiency.6317d00abcab533062449c2ddffd71a5.svg";
export { ForwardRef as ReactComponent };